export const GLOBAL = {
  urlConcentrado: 'https://www.api.app.playamia.com/api/v1/',
};
